import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const read = (k, fallback) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? fallback; } catch { return fallback; }
};

export const StoreProvider = ({ children }) => {
  const [cart, setCart] = useState(() => read("gp_cart", []));
  const [favourites, setFavourites] = useState(() => read("gp_favs", []));
  const [recent, setRecent] = useState(() => read("gp_recent", []));
  const [usage, setUsage] = useState(() => read("gp_usage", {}));
  const [techMode, setTechMode] = useState(() => read("gp_tech", false));

  useEffect(() => { localStorage.setItem("gp_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("gp_favs", JSON.stringify(favourites)); }, [favourites]);
  useEffect(() => { localStorage.setItem("gp_recent", JSON.stringify(recent)); }, [recent]);
  useEffect(() => { localStorage.setItem("gp_usage", JSON.stringify(usage)); }, [usage]);
  useEffect(() => { localStorage.setItem("gp_tech", JSON.stringify(techMode)); }, [techMode]);

  const addToCart = useCallback((sku, qty = 1) => {
    setCart((c) => {
      const found = c.find((i) => i.sku === sku);
      if (found) return c.map((i) => (i.sku === sku ? { ...i, qty: i.qty + qty } : i));
      return [...c, { sku, qty }];
    });
    setUsage((u) => ({ ...u, [sku]: (u[sku] || 0) + qty }));
  }, []);

  const setQty = useCallback((sku, qty) => {
    setCart((c) => (qty <= 0 ? c.filter((i) => i.sku !== sku) : c.map((i) => (i.sku === sku ? { ...i, qty } : i))));
  }, []);

  const removeFromCart = useCallback((sku) => setCart((c) => c.filter((i) => i.sku !== sku)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const toggleFav = useCallback((sku) => {
    setFavourites((f) => (f.includes(sku) ? f.filter((s) => s !== sku) : [sku, ...f]));
  }, []);

  const addRecent = useCallback((sku) => {
    setRecent((r) => [sku, ...r.filter((s) => s !== sku)].slice(0, 12));
  }, []);

  const cartCount = cart.reduce((n, i) => n + i.qty, 0);
  const mostUsed = Object.entries(usage).sort((a, b) => b[1] - a[1]).map(([sku]) => sku).slice(0, 8);

  return (
    <StoreContext.Provider value={{
      cart, cartCount, addToCart, setQty, removeFromCart, clearCart,
      favourites, toggleFav, recent, addRecent, mostUsed,
      techMode, setTechMode,
    }}>
      {children}
    </StoreContext.Provider>
  );
};
